module.exports = {
      id: "online-news-usage",
      viewBox: "0 0 56.84 35.647",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#online-news",
      toString: function () {
        return this.url;
      }
    }